import { render, staticRenderFns } from "./graduacao.vue?vue&type=template&id=22b8d2e8&scoped=true"
import script from "./graduacao.vue?vue&type=script&lang=js"
export * from "./graduacao.vue?vue&type=script&lang=js"
import style0 from "./graduacao.vue?vue&type=style&index=0&id=22b8d2e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b8d2e8",
  null
  
)

export default component.exports